module.exports = __webpack_public_path__ + "img/q3-7.a0c08636.png";